import type { SaveStatus } from '../app/store.js';

/** Text for `#save-status`; `idle` (nothing scheduled yet) shows nothing. */
export const SAVE_STATUS_TEXT: Record<SaveStatus, string> = {
  idle: '',
  pending: 'Сохраняется…',
  saved: 'Сохранено в этом браузере',
  failed: 'Не удалось сохранить в браузере. Изменения доступны, пока страница открыта.',
};

/** Writes the status text and a `data-status` hook for styling; no-op without the element. */
export function renderSaveStatus(
  status: SaveStatus,
  element: HTMLElement | null = document.getElementById('save-status'),
): void {
  if (!element) return;
  element.textContent = SAVE_STATUS_TEXT[status];
  element.dataset.status = status;
}
